
import { widgets } from "src/libs/layouts"
import { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { ALIGN, FONT_CASE, FONT_STYLE, LANDING_TYPE_CONTENT, LINKS_DESIGN_TYPE, OVERLAY_TYPE, PASSAGE_TYPE, SCROLLING_TYPE, SECTION_DESIGN_TYPE, SILHOUETTE, TAB_DESIGN_TYPE, TEXT_SIZE, VIDEO_PAYER_DESIGN_TYPE, WriterType } from "./interfaces"
import { LANDING_SCALAR } from "./landin_scalars"

import popover_animation_type from "src/assets/img/popover_animation_type.svg"
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { blueprintIcons, DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE, NAVIGATION_TYPE } from "src/libs/useful/gallery/Gallery"
import __image from "../assets/img/image.svg"
import __user from "../assets/img/user.svg"
import horizontal_tab from "./defaults/horizontal_tab"


export function LandingContentSchema () : any {
    let data ={
        [ LANDING_TYPE_CONTENT.HTML ]: {
            tabs: [ 
                {
                    _id: "incut",
                    title: "Incut setting",
                    description: "You can set a graphic or text element (or several elements of different types) to be wrapped around the text. Please note that if the incut contains another text block, it can also have its own incut."
                }, 
            ],
            text: {
                type: SCALAR_TYPES.TEXT,
                title: "Text", 
                placeholder: "Write text. May use css tags",
                rows: 4,
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, 
            columns: {
                type: SCALAR_TYPES.SLIDER,
                title: "Columns",
                min: 1,
                max: 8,
                stepSize: 1,
                labelStepSize: 1, 
                required: false,
                //parent:"text",
                thread: false,
                editable: true,
                noDefault: false,
                default: 1,
                tab: "main",
            },
            text_size: {
                type: SCALAR_TYPES.TAGS,
                title: "Text size", 
                values: Object.keys(TEXT_SIZE).map(key => ({
                    _id: key,
                    title: __( key )
                })),
                required: false,
                //parent:"text",
                thread: false,
                editable: true,
                default: TEXT_SIZE.NORMAL,
                noDefault: true,
                tab: "main",
            },
            gap: {
                type: SCALAR_TYPES.NUMBER,
                title: "Columns gap", 
                required: [ "columns", 2 ,3, 4, 5, 6, 7, 8 ],
                //parent:"text",
                thread: false,
                editable: true, 
                noDefault: true,
                default: 20,
                tab: "main",
            },
            max_length: {
                type: SCALAR_TYPES.NUMBER,
                title: "Cut length",
                commentary: "Max length of text before cut", 
                //required: [ "columns", 2 ,3, 4, 5, 6, 7, 8 ],
                //parent:"text",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            scroling: {
                type: SCALAR_TYPES.TAGS,
                title: "Text Scrolling", 
                values: Object.values(SCROLLING_TYPE).map(key => ({
                    _id: key,
                    title: __( key )
                })),
                required: false,
                //parent:"text",
                thread: false,
                editable: true,
                noDefault: true,
                default: SCROLLING_TYPE.Y,
                tab: "behovior",
            }, 
            incut: {
                type: LANDING_SCALAR.CONTENT,
                visualization: "landingCompositeDataType", 
                title: "Incut meats", 
                length: 1,
                required: [ "columns", 1 ], 
                tab: "incut",
            },
            incutWidth: {
                type: SCALAR_TYPES.CSS_MAGNITUDE,
                title: "Incut width", 
                required: [ "columns", 1 ],
                //parent:"incut",
                thread: false,
                editable: true,
                vertical: "vertical",
                noDefault: true,
                default: 350,
                tab: "incut",
            },
            incutHeight: {
                type: SCALAR_TYPES.CSS_MAGNITUDE,
                title: "Incut height", 
                required: [ "columns", 1 ],
                //parent:"incut",
                thread: false,
                editable: true,
                noDefault: true,
                default: 300,
                tab: "incut",
            },
            incutPosition: {
                type: SCALAR_TYPES.TAGS,
                values: [
                    {
                        _id: "left",
                        title: "By left of text"
                    },
                    {
                        _id: "right",
                        title: "By right of text"
                    },
                ],
                title: "Incut position", 
                required: [ "columns", 1 ],
                //parent:"incut",
                thread: false,
                editable: true,
                noDefault: true,
                default: "right",
                tab: "incut",
            }, 
            incutBorder: {
                type: SCALAR_TYPES.BORDER,
                title: "Incut border",
                required: [ "columns", 1 ],
                //parent:"incut",
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "incut",
            },
            background: {
                type: SCALAR_TYPES.COLOR,
                title: "Background color",  
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: "var(--force-contast-color)",
                tab: "style",
            },
            padding : {
                type: SCALAR_TYPES.NUMBER,
                title: "Padding", 
                thread: false,
                editable: true,
                noDefault: true,
                default:0,
                tab: "style",
            },
            link_url : {
                type: SCALAR_TYPES.STRING,
                title: "Link URL", 
                placeholder: "https://",
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "behovior",
            }, 
            link_target: {
                type: SCALAR_TYPES.TAGS,
                subtitle: "Link target",
                //parent: "link_url",
                values: [
                    {
                        _id: "_blank",
                        title: "Over window",
                    },
                    {
                        _id: "_self",
                        title: "This window",
                    },
                ],
                default:"_blank",
                required: false,
                thread: false,
                editable: true, 
                noDefault: false,
                tab: "behovior",
            },
        },
        [ LANDING_TYPE_CONTENT.BUTTONS ]: {
            buttons: {
                type: "external_array", 
                kind: "type",
                component: "ButtonContent",
                title: "Buttons", 
                required: true,
                thread: false,
                editable: true,
            }, 
            design_type: {
                type: SCALAR_TYPES.RADIO,
                values: Object.values(LINKS_DESIGN_TYPE).map(v => ({_id:v, title: v})),
                title: "Design type",  
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, 
            icon: {
                type: SCALAR_TYPES.ICON,
                title: "Icon", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            },
            button_color: {
                type: SCALAR_TYPES.COLOR,
                title: "Button color", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            },
            border_width: {
                type: SCALAR_TYPES.NUMBER,
                title: "Image width", 
                required: false,
                thread: false,
                editable: true,
                default: 1,
                tab: "main",
            },
            labelStyle:{
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Label CSS style", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }
        },
        [ LANDING_TYPE_CONTENT.CANVAS ]: { 
            floats: {
                type: "external_array",
                visualization: "landingCompositeDataType",
                component: "Float",
                title: "Items", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            }// ILandingFloat[]
        },
        [ LANDING_TYPE_CONTENT.CARDS ]: {
            tabs: [
                {
                    _id: "layout",
                    title: "Cards layout"
                }, 
                {
                    _id: "cards_type",
                    title: "Cards template"
                },
            ],
            cards: {
                type: LANDING_SCALAR.CARD, 
                component: "Card",
                visualization: "landingCompositeDataType",
                title: "Cards", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
            columns: {
                type: SCALAR_TYPES.SLIDER,
                title: "Columns",
                min: 1,
                max: 8,
                stepSize: 1,
                labelStepSize: 1, 
                required: false, 
                thread: false,
                editable: true, 
                tab: "style",
            },
            order: {
                type: LANDING_SCALAR.CARD_ORDER,
                visualization: "landingCompositeDataType",
                title: "What fields are displayed in cards?", 
                commentary: "Specify the fields that should appear on the cards. You can also change the order in which the fields appear on the cards.",
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
            // card_fields: CardFiled[]
            feedType : {
                type: SCALAR_TYPES.POPOVER,
                values:  Object.values(SECTION_DESIGN_TYPE)
                .filter( v => v !== SECTION_DESIGN_TYPE.FEED)
                .map(v => (
                    {
                        _id: v, 
                        title: __( v ), 
                        // description: __(`${ v } description`),
                        img: `/assets/img/landing/design_type_${v}.svg`, 
                        height: 75,
                        width: 75,
                    }
                )),
                height: 100,
                width: 150,
                stepSize: 2,
                title: "Design type", 
                commentary: "If there is more than one content element (second tab), they can be formatted in several ways.",
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                default: SECTION_DESIGN_TYPE.COLUMN,
                tab: "layout",
            }, 
            
            gap: {
                type: SCALAR_TYPES.SLIDER,
                subtitle: "Cards gap",
                min: 0,
                max: 40,
                stepSize: 1,
                labelStepSize: 10, 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                default:20,
                tab: "style",
            }, 
            is_back_image:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "is_back_image", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main-no-no-no",
            }, //,
            is_contrast_muar:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Set contrast muar on bottom", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            }, 
            back_color:  {
                type: SCALAR_TYPES.COLOR,
                subtitle: "back_color", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            is_back_dissolution:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "is_back_dissolution", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            color:  {
                type: SCALAR_TYPES.COLOR,
                subtitle: "color", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            }, 
            carousel_nav_type: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Carousel navigation button icons",
                values : Object.values( NAVIGATION_DESIGN_TYPE ).map(v => ({ _id:v, img: `/assets/img/landing/${ v }.svg`, height: 20, padding: 12 })),
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: false,
                default: NAVIGATION_DESIGN_TYPE.CHEVRON,
                tab: "layout",
            }, 
            carousel_nav_position: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Vertical position of carousel navigation buttons",
                values : Object.values( NAVIGATION_POSITION_TYPE ).map((v, i) => ({ _id:v, img: `/assets/img/landing/carousel-nav-0${ i + 1 }.svg`, height: 100 })),
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: false,
                default: NAVIGATION_POSITION_TYPE.TOP_LEFT,
                tab: "layout",
            }, 
            carousel_nav_size: {
                type: SCALAR_TYPES.TAGS,
                title: "Size of carousel navigation buttons",
                values : Object.values( NAVIGATION_SIZE_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            }, 
            carousel_nav_theme: {
                type: SCALAR_TYPES.TAGS,
                title: "Carousel navigation theme",
                values : Object.values( NAVIGATION_THEME_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            }, 
            carousel_nav: {
                type: SCALAR_TYPES.TAGS,
                title: "Carousel navigation buttons form",
                values : Object.values( NAVIGATION_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            }, 
            is_navigation:  {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Carousel pagination", 
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: false,
                tab: "layout",
            }, 
            carousel_autoplay:  {
                type: SCALAR_TYPES.TAGS,
                title: "Carousel autoplay duration", 
                values: [
                    {
                        _id: 0,
                        title: "none"
                    },
                    {
                        _id: 1000,
                        title: "1 sec"
                    },
                    {
                        _id: 2000,
                        title: "2 sec"
                    },
                    {
                        _id: 4000,
                        title: "4 sec"
                    },
                    {
                        _id: 5000,
                        title: "5 sec"
                    },
                    {
                        _id: 7000,
                        title: "7 sec"
                    },
                    {
                        _id: 10000,
                        title: "10 sec"
                    },
                    {
                        _id: 15000,
                        title: "15 sec"
                    },
                    {
                        _id: 30000,
                        title: "30 sec"
                    },
                ],
                required: ["feedType", SECTION_DESIGN_TYPE.CAROUSEL], 
                thread: false,
                editable: true,
                noDefault: false,
                tab: "layout",
            }, 
            /**Tab design */
            tabs_design_type: {
                type: SCALAR_TYPES.SELECT,
                title: "Tabs design type",
                values : Object.values( TAB_DESIGN_TYPE ).map( (v, iii) => ({ _id:v, title: horizontal_tab()[iii]?.title || v }) ),
                required: ["designType", SECTION_DESIGN_TYPE.TABS], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            }, 
            tab_design: { 
                type: "TabDesignStyle",
                component: "TabDesignStyle",
                title: "Tab design", 
                dataSection: "TabDesignStyle", 
                visualization: "landingCompositeDataType",
                required: ["designType", SECTION_DESIGN_TYPE.TABS], 
                thread: true,
                editable: true,
                isAlwaysOpen: false,
                isCollapsesOpen: false,
                tab: "layout",
            },
            /** Accordeon */
            haccordeon_design: {
                type: "HAccordeonStyle",
                component: "HAccordeonStyle",
                title: "Horizontal accordeon design", 
                dataSection: "HAccordeonStyle", 
                visualization: "landingCompositeDataType",
                required: ["designType", SECTION_DESIGN_TYPE.HACCORDEON, SECTION_DESIGN_TYPE.ACCORDEON], 
                thread: true,
                editable: true,
                isAlwaysOpen: true,
                isCollapsesOpen: true,
                tab: "layout",
            },
            /** Timeline */
            dots: {
                type:"TimelineDot",
                component: "TimelineDot",
                title: "Timeline design", 
                dataSection: "TimelineDot", 
                visualization: "landingCompositeDataType",
                required: [ "designType", SECTION_DESIGN_TYPE.VTIMELINE, SECTION_DESIGN_TYPE.HTIMELINE ], 
                thread: true,
                editable: true,
                isAlwaysOpen: true,
                isCollapsesOpen: true,
                tab: "layout",
            },

            border: {
                type: "Border",    
                visualization: "landingCompositeDataType", 
                subtitle: "Border",  
                required: true,
                //parent:"cards",
                isDefaultOpen:true,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            }, 
        },
        [ LANDING_TYPE_CONTENT.CATEGORY_LABEL ]: {
        },
        [ LANDING_TYPE_CONTENT.CHECK_BOX ]: {
        },
        [ LANDING_TYPE_CONTENT.CONTACTS ]: {
            items: {
                type: "external_array",
                kind: "sections",
                component: "ContactItem",
                title: "Contact Items",
                dataSection: "Contact Items", 
                visualization: "landingCompositeDataType",
                required: true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            }, 
            design_type: {
                type: SCALAR_TYPES.TAGS,
                title: "Design type",
                values : Object.values( LINKS_DESIGN_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, 
            carousel_count: {
                type: SCALAR_TYPES.NUMBER,
                title: "Carousel columns",  
                thread: false,
                editable: true, 
                noDefault: true, 
                tab: "main", 
            },
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            style: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                subtitle: "CSS style",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main", 
            },
            className: {
                type: SCALAR_TYPES.STRING,
                subtitle: "CSS classes", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            imageHeight: {
                type: SCALAR_TYPES.NUMBER,
                title: "Height of buttons image", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true, 
                isHidden: true, 
                tab: "main",
            },
            imageWidth: {
                type: SCALAR_TYPES.NUMBER,
                title: "Width of buttons image", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true, 
                isHidden: true, 
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.CONTACT_FORM ]: {
            tabs: [
                {
                    _id: "overlay",
                    title: "Overlay",
                    required: ["isOverlayButton", true],
                }, 
            ],
            thumbnail:{
                type: SCALAR_TYPES.MEDIA,
                title: "Thumbnail", 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "style",
            },
            title: {
                type: SCALAR_TYPES.STRING,
                title: "Title", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            },
            description: {
                type: SCALAR_TYPES.TEXT,
                title: "Description", 
                placeholder: "Write text. May use css tags",
                rows: 4,
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            },
            fields: {
                type: LANDING_SCALAR.FIELD_INPUT, 
                component: LANDING_SCALAR.FIELD_INPUT_ITEM,
                visualization: "landingCompositeDataType",
                title: "Fields", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            }, 
            sendButton: { 
                type: LANDING_TYPE_CONTENT.BUTTON, 
                component: LANDING_TYPE_CONTENT.BUTTON,
                visualization: "landingCompositeDataType",
                title: "Button", 
                required: false,
                thread: false,
                editable: true,                
                isDefaultOpen:false,
                isAlwaysOpen: false,
                isNotCard:true,
                tab: "style",
            },
            overlayType: { 
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Are you want set form in bottom form?",
                 values: Object.values( OVERLAY_TYPE ).map(key => ({
                    _id: key,
                    title: __( key + " descr" ),
                    commentary:__( key + " commentary" ),
                    description:__( key + " commentary" ),
                    img: `/assets/img/landing/overlay_type_${ key }.svg`, 
                    height: 75,
                })), 
                required: false,
                thread: false,
                editable: true,
                tab: "main",   
            }, 
            overlayBg: {
                type: SCALAR_TYPES.COLOR,
                title: "Overlay button color", 
                required: ["isOverlayButton", true],
                thread: false,
                editable: true,
                noDefault: true, 
                tab: "overlay",
            },
            overlayIcon: {
                type: SCALAR_TYPES.TAGS,
                title: "Icon on overlay buttons", 
                values: blueprintIcons.map(icon => ({
                    _id: icon,
                    icon: icon 
                })),
                required: ["isOverlayButton", true],
                thread: false,
                editable: true,
                noDefault: true,
                default: "phone-call",
                tab: "overlay",
            },
            overlayIconSize:  {
                type: SCALAR_TYPES.SLIDER,
                title: "Overlay button icon size", 
                min: 10,
                max: 40,
                stepSize: 1,
                labelStepSize: 5,
                required: ["isOverlayButton", true],
                thread: false,
                editable: true,
                default: 20,
                tab: "overlay",
            }, //
            overlayButtonSize: {
                type: SCALAR_TYPES.SLIDER,
                title: "Overlay button button size", 
                min: 40,
                max: 200,
                stepSize: 1,
                labelStepSize: 40,
                required: ["isOverlayButton", true],
                thread: false,
                editable: true,
                default: 40,
                tab: "overlay",
            },
            overlayBorder: {
                 type: SCALAR_TYPES.BORDER,
                subtitle: "Border",
                required: ["isOverlayButton", true],
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "overlay",
            },
            overlayBacklightAnimation: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Set backlight animation to overlay button", 
                required: ["isOverlayButton", true],
                thread: false,
                editable: true, 
                isHidden: true,
                tab: "main",
            }
        },
        [ LANDING_TYPE_CONTENT.CURVE ]: {
            
        },
        [ LANDING_TYPE_CONTENT.DIVIDER ]: { 
        },
        [ LANDING_TYPE_CONTENT.WRITER ]: { 
            visible_value: "text",
            text: {
                type: SCALAR_TYPES.HTML,
                title: "Text", 
                placeholder: "Start write",
                commentary: "Break text by enter for several lines.",
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            writerType: {
                type: SCALAR_TYPES.TAGS,
                title: "Animate design", 
                values: Object.values( WriterType ).map(key => ({
                    _id: key,
                    title: __( key ),
                    commentary:__( key ), 
                })),
                required: false,
                thread: false,
                editable: true,
                default: WriterType.PUSHKIN,
                noDefault: true,
                tab: "main", 
            }, 
            variant: {
                type: SCALAR_TYPES.IMAGE_RADIO_CAROUSEL,
                title: "Jumper type",
                values: Object.values( ANIMATED_STYLE ).map(v => ({
                    _id:v, 
                    title:__(v),
                    width: 120, 
                    height: 40, 
                    className: `animated ${v}`, 
                    img: popover_animation_type 
                })), 
                stepSize: 3,
                height: 40,
                required: [ "writerType", WriterType.JUMPER ],
                thread: false,
                editable: true,
                default: ANIMATED_STYLE.NONE,
                noDefault: true,
                tab: "main", 
            }
        },
        [ LANDING_TYPE_CONTENT.TWIRL_TEXT ]: { 

        },
        [ LANDING_TYPE_CONTENT.DOTS_NAVIGATION ]: { 
            tabs: [
                {
                    _id: "active-dot",
                    title: "Active dot design"
                },
                {
                    _id: "tooltip",
                    title: "Tooltip design"
                },
            ],
            items: {
                type: LANDING_SCALAR.DOT_NAVIGATION, 
                component: "DotNavidationItem",
                visualization: "landingCompositeDataType",
                title: "Items", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            }, //DotNavigation[]
            width:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Dot width", 
                required: false,
                thread: false,
                editable: true,
                tab: "design",
            }, //number
            height:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Dot height", 
                required: false,
                thread: false,
                editable: true,
                tab: "design",
            }, 
            color: {
                type: SCALAR_TYPES.COLOR,
                title: "Dot color", 
                required: false,
                noDefault: true, 
                thread: false,
                editable: true, 
                tab: "design",
            },  
            borderColor:  {
                type: SCALAR_TYPES.COLOR,
                title: "Dot border color", 
                required: false,
                thread: false,
                editable: true,
                onlyPlainColor: true,
                noDefault: true, 
                tab: "design",
            }, 
            borderWidth:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Dot border width", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "design",
            }, 
            borderRound:  {
                type: SCALAR_TYPES.SLIDER,
                title: "Dot round", 
                min:0,
                max: 50,
                stepSize: 1,
                labelStepSize: 10,
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "design",
            },
            activeColor:  {
                type: SCALAR_TYPES.COLOR,
                title: "Active dot color", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "active-dot",
            }, //Color
            activeBorderColor:  {
                type: SCALAR_TYPES.COLOR,
                title: "Active dot border color", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "active-dot",
            }, //Color
            activeBorderWidth:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Active dot border width", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "active-dot",
            }, //number
            activeWidth:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Active dot width", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "active-dot",
            }, //number
            activeHeight:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Active dot height", 
                required: false,
                thread: false,
                editable: true,
                    noDefault: true, 
                tab: "active-dot",
            }, //number
            gap:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Distance between dots", 
                required: false,
                thread: false,
                editable: true,
                tab: "composition",
            }, //number
            align:  {
                type: SCALAR_TYPES.SELECT,
                title: "Vertical align",
                values : Object.values( ALIGN ).map(v => ({ _id:v, title: __( v ) })),
                required: false,
                thread: false,
                editable: true,
                tab: "composition",
            }, //ALIGN
            distance:  {
                type: SCALAR_TYPES.NUMBER,
                title: "Distance to page border", 
                required: false,
                thread: false,
                editable: true,
                tab: "composition",
            }, //number
            tooltip:  {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Set tooltip", 
                required: false,
                thread: false,
                editable: true,
                tab: "tooltip",
            }, //boolean
            tooltipColor:  {
                type: SCALAR_TYPES.COLOR,
                title: "Tooltip color", 
                required: false,
                thread: false,
                editable: true,
                tab: "tooltip",
            }, //Color
            tooltipFontStyle:  {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "CSS", 
                required: false,
                thread: false,
                editable: true,
                tab: "tooltip",
            }, //CSSProperties
            design_type:  {
                type: SCALAR_TYPES.IMAGE_RADIO,
                values: Array(6).fill(0).map((_, i) => {
                    return { _id: i, title: i, img: "", height: 45 }
                }),
                title: "Design type", 
                required: ["LLL", "poo"],
                thread: false,
                editable: true,
                tab: "design--",
            }, //0 | 1 | 2 | 3 | 4 | 5
        },
        [ LANDING_TYPE_CONTENT.FB_GOODS ]: { 

        },
        [ LANDING_TYPE_CONTENT.FEATURES_CARDS ]: {
            tabs: [
                {
                    _id: "layout",
                    title: "Cards layout"
                }, 
                {
                    _id: "cards_type",
                    title: "Cards template"
                }, 
            ], 
            parentType2: LANDING_TYPE_CONTENT.CARDS,
        },
        [ LANDING_TYPE_CONTENT.GALLERY ]: {
            
        },
        [ LANDING_TYPE_CONTENT.HEADER ]: {
            tabs: [ 
                {
                    _id: "overtop",
                    title: "Overtop",
                    required: [ "isOvertopSwicth", true]
                },
            ],
            orders: { 
                type: LANDING_TYPE_CONTENT.HEADER_ORDER,
                title: "Meats and orders",
                visualization: "landingCompositeDataType",
                required: true,
                thread: true,
                editable: true,
                default: [ LANDING_TYPE_CONTENT.MENU, LANDING_TYPE_CONTENT.LOGO, LANDING_TYPE_CONTENT.CONTACTS ],
                tab: "main",
            },  
            vertical: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "The header elements are arranged vertically", 
                required: false,
                thread: false,
                editable: true, 
                default: false,
                noDefault: false,
                tab: "main",   
            }, 
            menu: {
                type: LANDING_TYPE_CONTENT.MENU,    
                visualization: "landingCompositeDataType",
                title: "Menu",
                subtitle: "Menu",  
                required: true,
                isDefaultOpen:false,
                isAlwaysOpen: false,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "",
            }, //?: MenuContent
            logo: {
                 type: LANDING_TYPE_CONTENT.LOGO,    
                visualization: "landingCompositeDataType",
                title: "Logo",
                subtitle: "Logo",  
                required: true,
                isDefaultOpen:false,                
                isAlwaysOpen: false,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "",
            }, //?: LogoContent
            contacts: {
                type: LANDING_TYPE_CONTENT.CONTACTS,    
                visualization: "landingCompositeDataType",
                title: "Contacts",
                subtitle: "Contacts",  
                required: true,
                isDefaultOpen:true,
                isAlwaysOpen:false,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "",
            }, //?: ContactsContent 
            isOvertopSwicth: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Fix the header at the top of the page after it disappears on scroll", 
                commentary: "You can change the structure of elements in the overtop header. Change settings are in the «Overtop» tab.",
                required: false,
                thread: false,
                editable: true, 
                default: false,
                noDefault: false, 
                tab: "main",  
            }, //?: boolean
            overtopMenu: {
                 type: LANDING_TYPE_CONTENT.MENU,    
                visualization: "landingCompositeDataType",
                title: "Overtop menu",
                subtitle: "Overtop menu",  
                //required: ["isOvertopSwicth", true],
                isDefaultOpen:true,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                isAlwaysOpen: false,
                tab: "overtop",
            }, //?: MenuContent
            overtopLogo: {
                 type: LANDING_TYPE_CONTENT.LOGO,    
                visualization: "landingCompositeDataType",
                title: "Overtop logo",
                subtitle: "Overtop logo",  
                //required: ["isOvertopSwicth", true],
                isDefaultOpen:true,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                isAlwaysOpen: false,
                tab: "overtop",
            }, //?: LogoContent
            overtopContacts: {
                 type: LANDING_TYPE_CONTENT.CONTACTS,    
                visualization: "landingCompositeDataType",
                title: "Overtop contacts",
                subtitle: "Overtop contacts",  
                //required: ["isOvertopSwicth", true],
                isDefaultOpen: true,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                isAlwaysOpen: false,
                tab: "overtop",
            }, 
            overtopBlurDrop: {
                type: SCALAR_TYPES.SLIDER,
                title: "Overtop drop blur",
                min:0,
                max: 20,
                stepSize: 1,
                labelStepSize: 5,
                //required: ["isOvertopSwicth", true],
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "overtop", 
            }, 
            overtopClassName: {
                type: SCALAR_TYPES.STRING,
                title: "Overtop CSS classes", 
                //required: ["isOvertopSwicth", true],
                thread: false,
                editable: true,
                noDefault: true,
                tab: "overtop",
            }, 
            overtopTypo: { 
                type: "Typographics",
                //required: ["isOvertopSwicth", true],
                component: "Typographics",
                title: "Overtop Typographics", 
                dataSection: "Typographics", 
                dataName: "position",
                visualization: "landingCompositeDataType",
                required: true,
                isDefaultOpen:false,                
                isAlwaysOpen: false,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "overtop",
            }, 
        },
        [ LANDING_TYPE_CONTENT.ICON ]: {
            src: {
                type: SCALAR_TYPES.ICON,
                title: "Icon", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: "fas fa-home",
                tab: "main",
            },  
            size : {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Size", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            className : {
                type: SCALAR_TYPES.STRING,
                subtitle: "CSS classes", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, // string
            style:{
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "CSS style", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //  CSSProperties
        },
        [ LANDING_TYPE_CONTENT.IMAGE ]: {
            src: {
                type: SCALAR_TYPES.MEDIA,
                title: "Image", 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            }, 
            src_type: {         
                type: SCALAR_TYPES.TAGS,
                values: [
                    {
                        _id: "src",
                        title: "Image"
                    },
                    {
                        _id: "div",
                        title: "Cropped filled element"
                    }
                ],
                subtitle: "Design type", 
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            original_size:{
                isHidden: true,
            }, 
            background_position_x: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Background horizontal shift", 
                parent: "src",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            hover_size: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Hover size", 
                //parent: "src",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            width_fixed: {
                isHidden: true,
            }, 
            description_title: {
                type: SCALAR_TYPES.HTML,
                title: "Title", 
                placeholder: "Start write",
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "description",
            }, 
            description: {
                type: SCALAR_TYPES.HTML,
                title: "Description", 
                placeholder: "Start write",
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "description",
            }, 
            description_style:{
                type: SCALAR_TYPES.CSS_PROPERTIES,
                subtitle: "Description CSS style", 
                //parent: "description",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "description",
            },  
            description_class_name: {
                type: SCALAR_TYPES.STRING,
                subtitle: "Description's css class names",
                placeholder: "Write SCC class names separated by spaces",
                parent: "description", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "description",
            }, 
            is_contrast_muar:{
                type: SCALAR_TYPES.BOOLEAN,
                title: "Set contrast muar on bottom", 
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            width: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Width", 
                parent: "src",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            },
            height: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Height", 
                parent: "src",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            }, 
            exact_value: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Extract value", 
                parent: "src",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                isHidden: true,
                tab: "main",
            },
            className : {
                type: SCALAR_TYPES.STRING,
                subtitle: "CSS classes", 
                placeholder: "Write SCC class names separated by spaces",
                //parent: "src",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            link_url : {
                type: SCALAR_TYPES.STRING,
                title: "Link URL", 
                placeholder: "https://",
                //parent: "src", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            link_target: {
                type: SCALAR_TYPES.TAGS,
                subtitle: "Link target",
                //parent: "link_url",
                values: [
                    {
                        _id: "_blank",
                        title: "Over window",
                    },
                    {
                        _id: "_self",
                        title: "This window",
                    },
                ],
                default:"_blank",
                required: false,
                thread: false,
                editable: true, 
                noDefault: false,
                tab: "main",
            },
        },
        [ LANDING_TYPE_CONTENT.MARRIAGE ]: {
            text: {
                type: "html", 
                component: "html",
                visualization: "landingCompositeDataType",
                length: 6,
                title: "Text", 
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            image0: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 1", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image1: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 2", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image2: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 3", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image3: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 4", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image4: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 5", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image5: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 6", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image6: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 7", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image7: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 8", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image8: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 9", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image9: {
                kind: "type",
                type: LANDING_SCALAR.MARRIAGE_ITEM,
                component: LANDING_SCALAR.MARRIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 10", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
            hover_size: {
                type: SCALAR_TYPES.NUMBER,
                title: "Hover size", 
                required: false,
                thread: false,
                editable: true,
                default: 1,
                tab: "main",
            }, // number 
            imageStyle: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Images styles",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style",
            }, 
            imageBorder: {
                type: SCALAR_TYPES.BORDER,
                title: "Images's border",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            },
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.MENU ]: {
            // menuId?: keyof IRoutingData
            items : {
                type: "external_array",
                kind: "sections",
                component: "MenuItem",
                title: "Menu Items",
                dataSection: "Menu Items", 
                visualization: "landingCompositeDataType",
                required: true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            },//?: IMenuItem[] 
            design_type: {
                type: SCALAR_TYPES.TAGS,
                title: "Design type",
                values: [
                    {
                        _id: "iconic",
                        title: "iconic",
                    },
                    {
                        _id: "inline",
                        title: "inline",
                    },
                ],
                default:"inline",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            }, 
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "behovior",
            }, 
        },
        [ LANDING_TYPE_CONTENT.ORDER ]: { 

        },
        [ LANDING_TYPE_CONTENT.PERSON ]: {
            user: {
                type: "User",    
                visualization: "landingCompositeDataType",
                title: "User",
                subtitle: "User", 
                icon: __user,
                required: true,
                isDefaultOpen:true,
                isNotCard:true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            }, //IUser
            avatarWidth: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Avatar width", 
                parent:"user",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: 90,
                tab: "main",
            }, //number,
            avatarHeight: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Avatar height", 
                parent:"user",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: 90,
                tab: "main",
            }, //number,
            avatarClassName: {
                type: SCALAR_TYPES.STRING,
                subtitle: "Avatar CSS classes",
                parent:"user", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: 90,
                tab: "main",
            }, //string
            isVertical: {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Vertical layout", 
                title: "Vertical layout", 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                default: false,
                tab: "main",
            }, //boolean,
            border: {
                type: SCALAR_TYPES.BORDER,
                subtitle: "Avatar border",
                parent:"user",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            }, //CSSBorder
            hover_size: {
                type: SCALAR_TYPES.NUMBER,
                subtitle: "Hover size", 
                parent:"user",
                required: false,
                thread: false,
                editable: true,
                default: 1,
                noDefault: true,
                tab: "main",
            }, //string
        },
        [ LANDING_TYPE_CONTENT.PERSONAL_CARDS ]: {
            tabs: [
                {
                    _id: "layout",
                    title: "Cards layout"
                }, 
                {
                    _id: "cards_type",
                    title: "Cards template"
                }, 
            ], 
            parentType2: LANDING_TYPE_CONTENT.CARDS,
        },
        [ LANDING_TYPE_CONTENT.SHEDULE_CARDS ]: { 
            tabs: [
                {
                    _id: "layout",
                    title: "Cards layout"
                },
                {
                    _id: "cards_type",
                    title: "Cards template"
                }, 
            ], 
            parentType2: LANDING_TYPE_CONTENT.CARDS,
        },
        [ LANDING_TYPE_CONTENT.TABLE ]: {
            
        },
        [ LANDING_TYPE_CONTENT.TABS ]: {
            
        },
        [ LANDING_TYPE_CONTENT.TAGS ]: {
            
        },
        [ LANDING_TYPE_CONTENT.TESTINOMIALS ]: {
            tabs: [
                {
                    _id: "layout",
                    title: "Cards layout"
                },  
                {
                    _id: "cards_type",
                    title: "Cards template"
                }, 
            ], 
            parentType2: LANDING_TYPE_CONTENT.CARDS,
        },
        [ LANDING_TYPE_CONTENT.TIME ]: {
            
        },
        [ LANDING_TYPE_CONTENT.VERNISSAGE ]: {  
            cover: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Cover image", 
                commentary: "",
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //MarriageItem 
            order: {
                type: LANDING_SCALAR.CONTENT,
                visualization: "landingCompositeDataType",
                length: 1,
                title: "Accent", 
                commentary: "A medallion with free content. You can insert an image, a serial number, an icon, etc.",
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            text: {
                type: "html", 
                component: "html",
                visualization: "landingCompositeDataType",
                length: 6,
                title: "Text", 
                commentary: "",
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //HTMLContent
            coverTitle: {
                type: "html", 
                component: "html",
                visualization: "landingCompositeDataType",
                length: 6,
                title: "Cover text", 
                commentary: "",
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //HTMLContent
            coverTitle2: {
                type: "html", 
                component: "html",
                visualization: "landingCompositeDataType",
                length: 6,
                title: "Cover subtitle", 
                commentary: "",
                required: true,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //HTMLContent
            image0: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 1", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image1: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 2", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image2: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 3", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image3: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 4", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image4: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 5", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            image5: {
                kind: "type",
                type: LANDING_SCALAR.MARIAGE_ITEM,
                component: LANDING_SCALAR.MARIAGE_ITEM,
                visualization: "landingCompositeDataType",
                title: "Image 6", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            hover_size: {
                type: SCALAR_TYPES.NUMBER,
                title: "Hover size", 
                required: false,
                thread: false,
                editable: true,
                default: 1,
                tab: "main",
            }, // number 
            imageStyle: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Images styles",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style",
            }, 
            imageBorder: {
                type: SCALAR_TYPES.BORDER,
                title: "Images's border",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            },
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.VK_VIDEO ]: { 
            src: {
                type: SCALAR_TYPES.STRING,
                title: "Source", 
                required: false,
                commentary: "Copy embed code (right click on player)",
                thread: false,
                editable: true, 
                tab: "main",
            }, 
            image: {
                type: SCALAR_TYPES.MEDIA,
                title: "Thumbnail", 
                width: 380,
                height: 230,
                required: false,
                thread: false,
                editable: true, 
                tab: "main",
            }, 
            label: {
                type: SCALAR_TYPES.HTML,
                title: "Label", 
                required: true,
                thread: false,
                editable: true,
                default: 20,
                tab: "main",
            },
            content: {
                type: SCALAR_TYPES.HTML,
                title: "Description", 
                required: true,
                thread: false,
                editable: true, 
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.VK_VIDEO_PLAYLIST ]: {
            tabs: [ 
                {
                    _id: "layout",
                    title: "Layout"
                }, 
            ],
            items: {
                type: LANDING_SCALAR.VK_VIDEO, 
                visualization: "landingCompositeDataType",
                component: LANDING_TYPE_CONTENT.VK_VIDEO,
                title: "Items", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",    
            }, // VKVideoItem[] 
            playerDesign: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Playlist design", 
                values: Object.values( VIDEO_PAYER_DESIGN_TYPE ).map((key, i) => ({
                    _id: key,
                    title: __( key ),
                    img: `/assets/img/landing/vk-playlist-0${i + 1}.svg`,
                    height: 95,
                    commentary:__( key ), 
                })),
                required: false,
                thread: false,
                editable: true,
                default: VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, 
                tab: "layout", 
            }, // ?: VIDEO_PAYER_DESIGN_TYPE
            btnWidth: {
                type: SCALAR_TYPES.NUMBER,
                title: "Player width", 
                required: [ "playerDesign", VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST ],
                thread: false,
                editable: true,
                default: 640,
                noDefault: true,
                tab: "main",
            }, // ?:  number
            btnHeight: {
                type: SCALAR_TYPES.NUMBER,
                title: "Player height", 
                required: false,
                thread: false,
                editable: true,
                default: 380,
                noDefault: true,
                tab: "main",
            }, // ?: number
            /*
            padding: {
                type: SCALAR_TYPES.NUMBER,
                title: "Padding", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: 0,
                noDefault: true,
                tab: "main",
            }, // ?:   number 
            intent: {
                type: SCALAR_TYPES.TAGS,
                title: "Intent", 
                values: Object.values( Intent ).map(key => ({
                    _id: key,
                    title: __( key ),
                    commentary:__( key ), 
                })),
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST ],
                thread: false,
                editable: true,
                default: Intent.NONE,
                noDefault: true,
                tab: "main", 
            }, // ?:    Intent | string
            minimal: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Is button minimal?", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: false,
                noDefault: true,
                tab: "main",
            }, // ?:   boolean            
            fill: {
                type: SCALAR_TYPES.NUMBER,
                title: "Ignore player width and fill by container?", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: true,
                noDefault: true,
                tab: "main",
            }, // ?:      boolean            
            image: {
                type: SCALAR_TYPES.MEDIA,
                title: "Thumbnail", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true, 
                tab: "main",
            }, // ?:     URL | string
            label: {
                type: SCALAR_TYPES.STRING,
                title: "Label", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: 20,
                tab: "main",
            }, // :      string
            isAutoMode: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Auto play", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: false,
                noDefault: true,
                tab: "main",
            }, // ?: boolean
            isPlayButton: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Enable play button", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: 20,
                noDefault: true,
                tab: "main",
            }, // ?: boolean
            */
            isModal: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Is play in modal?", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST,VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                default: false,
                noDefault: true,
                tab: "main",
            }, // ?:   boolean
            descriptionAfter: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Put description after video player?", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST],
                thread: false,
                editable: true,
                default: false,
                noDefault: true,
                tab: "main",
            }, // ?:   boolean
            /*
            containerWidth: {
                type: SCALAR_TYPES.NUMBER,
                title: "Container width", 
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            }, // ?: number
            */
            columnsCount: {
                type: SCALAR_TYPES.NUMBER,
                title: "Pictograms column count", 
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.TILE],
                thread: false,
                editable: true,
                min:1,
                max: 8,
                default: 1,
                noDefault: true,
                tab: "style",
            },
            navigationPositionType : {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Vertical position of carousel navigation buttons",
                values : Object.values( NAVIGATION_POSITION_TYPE ).map((v, i) => ({ _id:v, img: `/assets/img/landing/carousel-nav-0${ i + 1 }.svg`, height: 100 })),
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.CAROUSEL, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS], 
                thread: false,
                editable: true,
                noDefault: false,
                default: NAVIGATION_POSITION_TYPE.TOP_LEFT,
                tab: "layout",
            },
            navigationSizeType: {
                type: SCALAR_TYPES.TAGS,
                title: "Size of carousel navigation buttons",
                values : Object.values( NAVIGATION_SIZE_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.CAROUSEL, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            },
            navigationThemeType: {
                type: SCALAR_TYPES.TAGS,
                title: "Carousel navigation theme",
                values : Object.values( NAVIGATION_THEME_TYPE ).map(v => ({ _id:v, title: __( v ) })),
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.CAROUSEL, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS], 
                thread: false,
                editable: true,
                noDefault: true,
                tab: "layout",
            },
            navigationDesignType: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Carousel navigation button icons",
                values : Object.values( NAVIGATION_DESIGN_TYPE ).map(v => ({ _id:v, img: `/assets/img/landing/${ v }.svg`, height: 20, padding: 12 })),
                required: ["playerDesign", VIDEO_PAYER_DESIGN_TYPE.CAROUSEL, VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS],
                thread: false,
                editable: true,
                noDefault: false,
                default: NAVIGATION_DESIGN_TYPE.CHEVRON,
                tab: "layout",
            },
        },
        [ LANDING_TYPE_CONTENT.WIDGET ]: { 
            widgetId: {
                type: SCALAR_TYPES.SELECT,
                values: Object.keys(widgets()).map(key => ({
                    _id: key,
                    title: __( widgets()[key].title )
                })),
                title: "Widget",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            },
            attributes: {
                type: SCALAR_TYPES.OPTIONS,
                title: "Attributes",
                commentary: "See PE documentation",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            }
        },
        [ LANDING_TYPE_CONTENT.YANDEX_MAP ]: {
            
        },
        [ LANDING_TYPE_CONTENT.ZOOM_PANCH_PINCH ]: {
            minScale: {
                type: SCALAR_TYPES.SLIDER,
                title: "Min scale",
                min: 0.1,
                max: 2,
                stepSize: 0.1,
                labelStepSize: 0.1, 
                required: false, 
                thread: false,
                editable: true, 
                default: 1,
                tab: "main",
            }, 
            maxScale: {
                type: SCALAR_TYPES.SLIDER,
                title: "Max scale",
                min: 1,
                max: 8,
                stepSize: 1,
                labelStepSize: 1, 
                required: false, 
                thread: false,
                editable: true, 
                default: 5,
                tab: "main",
            }, 
            // section: {
            //     type: "external_array",
            //     kind: "sections",
            //     component: "Section",
            //     title: "Sections",
            //     dataSection: "Section", 
            //     visualization: "landingCompositeDataType",
            //     required: true,
            //     thread: false,
            //     editable: true,
            //     tab: "main",
            //     is_hidden: true,
            // }, 

            
            incut: {
                type: LANDING_SCALAR.CONTENT,
                visualization: "landingCompositeDataType", 
                title: "Contents", 
                max: 1,
                required: true, 
                default: {
                    type: LANDING_TYPE_CONTENT.DATA_CONTENT,
                    data:[{
                        width: 930,
                        height: 930,
                        src: "https://i4.imageban.ru/thumbs/2026.09.01/aad36e4c4905494d2af899a6a6fa9947.jpg",
                        hover_size: 1.1,
                        type: LANDING_TYPE_CONTENT.IMAGE
                    }]
                },
                tab: "main",
            },
            incutWidth: {
                type: SCALAR_TYPES.CSS_MAGNITUDE,
                title: "Contents width", 
                required: false, 
                thread: false,
                editable: true,
                vertical: "vertical",
                noDefault: false,
                default: 920,
                tab: "incut",
            },
            incutHeight: {
                type: SCALAR_TYPES.CSS_MAGNITUDE,
                title: "Contents height", 
                required: false, 
                thread: false,
                editable: true,
                noDefault: false,
                default: 920,
                tab: "incut",
            }, 
        },
        [ LANDING_TYPE_CONTENT.INFO_GRAPHICS ]: { 
            tabs: [ 
                {
                    _id: "layout",
                    title: "Cards layout"
                },
                {
                    _id: "cards_type",
                    title: "Cards template"
                }, 
            ], 
            parentType2: LANDING_TYPE_CONTENT.CARDS,
            cards: {
                type: LANDING_SCALAR.CARD, 
                component: "Card",
                visualization: "landingCompositeDataType",
                title: "Cards", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            }, // ICard[]
            gap: {
                type: SCALAR_TYPES.NUMBER,
                title: "Cards gap", 
                required: false,
                thread: false,
                editable: true,
                default: 1,
                noDefault: true,
                tab: "main",
            }, // number,
            silhouette: {
                type: SCALAR_TYPES.IMAGE_RADIO_CAROUSEL,
                title: "Central diagramm",
                values : Object.values( SILHOUETTE ).map(v => ({
                    _id: v, 
                    title:  __( v ),
                    img: `/assets/img/landing/silhouette/${v}.svg`,
                    height: 110,
                    width: 110
                })),
                columns: 2,
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, // SILHOUETTE, 
            silhouette_gap: {
                type: SCALAR_TYPES.NUMBER,
                title: "Gap in figure's sections", 
                required: false,
                thread: false,
                editable: true,
                default: 1,
                noDefault: true,
                tab: "main",
            }, // number,
            src: {
                type: SCALAR_TYPES.MEDIA,
                title: "Mask image", 
                commentary: "Black imge with opacity by svg file format",
                required: ["silhouette", SILHOUETTE.SOURCE],
                thread: false,
                editable: true,
                default: "chess-horse",
                tab: "main",
            }, // URL 
            title: {
                type: SCALAR_TYPES.HTML,
                title: "Label text", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, // HTML
            description: {
                type: SCALAR_TYPES.HTML,
                title: "Description", 
                required: false,
                thread: false,
                editable: true,
                tab: "main",
            }, // HTML
            dotSize: {
                type: SCALAR_TYPES.NUMBER,
                title: "Dot size", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                default: 20,
                tab: "main",
            }, // number
            size: {
                type: SCALAR_TYPES.NUMBER,
                title: "Figure size per px", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, // number,
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.LOGO ]: {  
             src: {
                type: SCALAR_TYPES.MEDIA,
                title: "Image", 
                required: true,
                thread: false,
                editable: true,  
                width: 290,
                icon: __image,
                tab: "main",
            }, // URL 
            title: {
                type: SCALAR_TYPES.HTML,
                title: "Title", 
                placeholder: "Start write",
                required: false,
                thread: false,
                editable: true, 
                noDefault: false,
                tab: "main",
            }, // HTML
            description: {
                type: SCALAR_TYPES.HTML,
                title: "Description", 
                placeholder: "Start write",
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            }, // HTML 
            commentary: {
                type: SCALAR_TYPES.HTML,
                placeholder: "Start write",
                title: "Commentary", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, // HTML 
            link_url: {
                type: SCALAR_TYPES.STRING,
                title: "link url", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //URL | string
            link_target: {
                type: SCALAR_TYPES.TAGS,
                subtitle: "Link target",
                values: [
                    {
                        _id: "_blank",
                        title: "Over window",
                    },
                    {
                        _id: "_self",
                        title: "This window",
                    },
                ],
                default:"_blank",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "main",
            },//URL | string 
              
            titleStyle: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Title styles",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style",
            }, 
            descriptionStyle: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Description styles",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style",
            }, 
            commentaryStyle: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Commentary styles",
                required: false,
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style",
            },  
            vertical: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Is vertical", 
                required: false,
                thread: false,
                editable: true, 
                default: false,
                noDefault: false,
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.THUMBNAIL_TILE ]: { 
            images: {
                type: SCALAR_TYPES.GALLERY,
                title: "Images",
                dataSection: "Images",  
                required: true,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "main",
            },
            gap: {
                type: SCALAR_TYPES.NUMBER,
                title: "Gap", 
                thread: false,
                editable: true, 
                noDefault: true,
                default: 0,
                tab: "main",
            },
            animated: {
                type: LANDING_SCALAR.ANIMATED, 
                title: "Animation", 
                visualization: "landingCompositeDataType",
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, 
        },
        [ LANDING_TYPE_CONTENT.PASSAGE ]: { 
            items: {
                type: "external_array",
                visualization: "landingCompositeDataType",
                component: LANDING_TYPE_CONTENT.IMAGE,
                title: "Items", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
            passageType: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                title: "Design type", 
                values: Object.values(PASSAGE_TYPE).map(key => ({
                    _id: key,
                    title: __( key ),
                    img: `/assets/img/landing/passage_type_${ key }.svg`,
                    height: 60
                })),
                required: false, 
                thread: false,
                editable: true,
                noDefault: true,
                default: PASSAGE_TYPE.SYNCHRONOUS,
                tab: "main",
            },
            itemHeight: {
                type: SCALAR_TYPES.NUMBER,
                title: "Item height", 
                required: [ "passageType", PASSAGE_TYPE.SYNCHRONOUS, PASSAGE_TYPE.HORIZONTAL ],
                //parent:"items",
                thread: false,
                editable: true,
                noDefault: true,
                default: 300,
                tab: "main",
            },
            columns: {
                type: SCALAR_TYPES.NUMBER,
                title: "Columns", 
                subtitle: "Columns", 
                required: [ "passageType", PASSAGE_TYPE.SYNCHRONOUS, PASSAGE_TYPE.SQUARE, PASSAGE_TYPE.MASONRY ],
                //parent:"items",
                thread: false,
                editable: true,
                noDefault: true,
                default: 3,
                tab: "main",
            },
            gap: {
                type: SCALAR_TYPES.SLIDER,
                subtitle: "Gap",
                title: "Gap",
                min: 0,
                max: 40,
                stepSize: 1,
                labelStepSize: 10, 
                required: false,
                //parent:"items",
                thread: false,
                editable: true,
                noDefault: false, 
                default: 0,
                tab: "style",
            },
            hover_size: {
               type: SCALAR_TYPES.NUMBER,
                subtitle: "Hover size", 
                //parent: "items",
                required: false,
                thread: false,
                editable: true,
                isHidden: true,
                noDefault: true,
                tab: "main", 
            },
            src_type: {
                type: SCALAR_TYPES.TAGS,
                values: [
                    {
                        _id: "src",
                        title: "Image"
                    },
                    {
                        _id: "div",
                        title: "Cropped filled element"
                    }
                ],
                subtitle: "Design type", 
                // parent: "items",
                isHidden: true,
                required: false,
                thread: false,
                editable: false,
                noDefault: true,
                default: "src",
                tab: "main", 
            },
            galleryType: {
                type: SCALAR_TYPES.TAGS,
                values: [
                    {
                        _id: "image",
                        title: "Image"
                    },
                    {
                        _id: "div",
                        title: "Cropped filled element"
                    },
                    {
                        _id: "span",
                        title: "span"
                    },
                    {
                        _id: "element",
                        title: "element"
                    },
                ],
                subtitle: "Gallery type", 
                required: false,
                thread: false,
                editable: true,
                isHidden: true,
                noDefault: true,
                default:"image",
                tab: "main",
            }, 
            galleryContainerClassName: {
                type: SCALAR_TYPES.STRING,
                subtitle: "Container CSS classes", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            border: {
               type: SCALAR_TYPES.BORDER,
                subtitle: "Incut border",
                required: [ "columns", 1 ],
                // parent:"items",
                thread: false,
                editable: true, 
                noDefault: true,
                tab: "style", 
            }, 
        }, 
        [ LANDING_TYPE_CONTENT.DATA_CONTENT ]: { 
            data: {
                type: "external_array",
                component: "LandingContent",
                visualization: "landingCompositeDataType",
                title: "Meats", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
        },
        [ LANDING_TYPE_CONTENT.RANDOM_CONTENT ]: { 
            data: {
                type: "external_array",
                component: "LandingContent",
                visualization: "landingCompositeDataType",
                dataSection: "data",
                title: "Meats", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
            isNextButton: {
                type: SCALAR_TYPES.BOOLEAN,
                title: "Set button «Next element»", 
                required: false,
                thread: false,
                editable: true, 
                default: true,
                noDefault: false,
                tab: "main",
            },
            nextButtonLabel: {
                type: SCALAR_TYPES.HTML,
                title: "Next element button label", 
                required: ["isNextButton", true],
                thread: false,
                editable: true, 
                default: "Next element",
                noDefault: false,
                tab: "main",
            },
            font_size: {
                type: SCALAR_TYPES.NUMBER,
                title: "Font size",
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                default: 9,
                tab: "typo",
            },
            font_case: {
                type: SCALAR_TYPES.TAGS,
                values: Object.values(FONT_CASE).map(key => ({ _id:key, title:__( key ), style:{ textTransform: key } })),
                title: "Font case", 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "typo",
            },
            font_style: {
                type: SCALAR_TYPES.TAGS,
                values: Object.values(FONT_STYLE).map(key => ({ _id:key, title:__( key ), style:{ textTransform: key } })),
                title: "Font style", 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "typo",
            }, 
            line_height: {
                type: SCALAR_TYPES.SLIDER, 
                title: "Line height",
                min:0,
                max:5,
                stepSize: 0.1,
                labelStepSize: 2.5, 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                tab: "typo",
            },
            letter_spacing: {
                type: SCALAR_TYPES.SLIDER, 
                title: "Letter spacing",
                min:0,
                max:10,
                stepSize:1,
                labelStepSize: 5, 
                required: false,
                thread: false,
                editable: true,
                noDefault: false,
                default:3,
                tab: "typo",
            },
        },
        [ LANDING_TYPE_CONTENT.LINKS_FEED ]: { 
            items: {
                type: "external_array",
                component: "ExternalLink",
                visualization: "landingCompositeDataType",
                dataSection: "data",
                title: "External links feed", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            }, 
            columns: {
                type: SCALAR_TYPES.NUMBER,
                title: "Columns", 
                subtitle: "Columns", 
                required: 1,
                //parent:"items",
                thread: false,
                editable: true,
                noDefault: true,
                default: 1,
                tab: "main",
            },
            isCategoryFiltered:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Category filter enabled", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            isOrder:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Order sort handlers enabled", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            isStatusFiltered:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Status filter enabled",
                commentary: "'No viewed', 'Viewed' or 'Archived'", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            isTopPagination:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Top pagination", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            isAdd:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "User may add mew item", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            isRating:  {
                type: SCALAR_TYPES.BOOLEAN,
                subtitle: "Every user may rate items", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            }, //,
            extendedHandlers:  {
                type: LANDING_SCALAR.EXTERNAL_LINK_FEED, 
                visualization: "landingCompositeDataType", 
                required: false,
                //parent:"cards",
                thread: false,
                editable: true,
                noDefault: true,
                tab: "behovior",
            }, //,
        },
        [ LANDING_TYPE_CONTENT.MODAL ]: { 
            title: {
                type: SCALAR_TYPES.HTML,
                title: "Title", 
                placeholder: "Start write",  
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "main",
            },
            content: {
                type: LANDING_SCALAR.CONTENT,
                visualization: "landingCompositeDataType", 
                title: "Contents", 
                required: true,
                thread: false,
                editable: true,
                tab: "main",
            },
            size: {
                type: SCALAR_TYPES.IMAGE_RADIO,
                values: Object.values( DIALOG_SIZE ).map( key => ({
                    _id: key,
                    title: __( key ),
                    img: `/assets/img/landing/dialog_size_${ key.toLowerCase() }.svg`,
                    height: 60
                }) ),
                title: "Modal size", 
                required: true,
                thread: false,
                editable: true,
                default: DIALOG_SIZE.NORMAL,
                tab: "main",
            },
            dialogCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Dialog CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            dialogTitleCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Dialog title CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            footerCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Dialog footer CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            portalCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Dialog portal's CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            contentCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Dialog Content's CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            titleElementsCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Top dialog element CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
            footerElementsCSS: {
                type: SCALAR_TYPES.CSS_PROPERTIES,
                title: "Bottom dialog element CSS", 
                required: false,
                thread: false,
                editable: true,
                noDefault: true,
                tab: "style",
            },
        },
    }
    return data
}